export default __webpack_public_path__ + "static/media/DSC_0505.09f7cc61.jpg";